import { Button, Container, Stack } from 'react-bootstrap'
import ScrollAnimationWrapper from '../Other/ScrollAnimationWrapper'
import { Link } from 'react-router-dom'
import TrustedBySection from '../Other/TrustedBySection'

function HomeHeroSection() {
  return (
    <Stack 
        className="hero-section text-center"
        style={{
            backgroundImage: 'url(/images/QuickyChat-bg-2.png)',
            backgroundSize:'cover',
            backgroundPosition:'center',
            backgroundRepeat:'no-repeat',
            overflow:'hidden'
        }}>
        
        <Container className='px-4' style={{maxWidth:'800px',margin:'2em auto'}}>
            <ScrollAnimationWrapper>
                <h1 className="big-header">Build Custom AI ChatBots in Minutes</h1>
                <p>Quickly create AI-powered chatbots that respond with precision and depth.</p>
                <Link to="/dashboard">
                    <Button variant="primary" size="lg">
                        Start Building for Free
                    </Button>
                </Link>
            </ScrollAnimationWrapper>
        </Container>
        <Container className='px-4' style={{maxWidth:'800px',margin:'0 auto'}}>
            <ScrollAnimationWrapper>
                <TrustedBySection/>
            </ScrollAnimationWrapper>
        </Container>
    </Stack>
  )
}

export default HomeHeroSection